<ng-table 
    [config]="config" 
    [columns]="columns"
    [data]="requestsData"
    (cellClicked)="onCellClick($event)"
></ng-table>
